import { VueRecaptchaPlugin } from "./index.mjs";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
export default defineNuxtPlugin(({ vueApp }) => {
  const {
    public: { recaptcha }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  } = useRuntimeConfig();
  vueApp.use(VueRecaptchaPlugin, recaptcha);
});
